import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AccountContext } from '../contexts/AccountContext';
import { useReviewCenterData }from '../contexts/ReviewCenterContext'
import buildLink from '../urls';
import _axios from '../axios';
import DotsLoader from '../components/DotsLoader';
import SingleProduct from '../components/SingleProduct';

function ReviewCenter() {
  const [awaitingReview, setAwaitingReview] = useState(true);
  const navigate = useNavigate();
  const [stateAccount,dispatch] = useContext(AccountContext)
  const { reviewCenterData, setReviewCenterData } = useReviewCenterData();
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState();

  useEffect(() =>{

    if (!stateAccount.loading && !stateAccount.loged) {
      navigate("/");
    } else if (stateAccount.loged) {
      setLoading(true);
      if (awaitingReview) {
        _axios
          .get(
            buildLink("unreviewedProtuctsCenter", undefined, window.innerWidth)
          )
          .then((response) => {
            setLoading(false);
            const data = response.data;
            console.log(response.data);
            
            setData(data);
            if (!stateAccount.loged) {
              navigate("/");
            }
          });
      } else {
        _axios
          .get(
            buildLink("reviewedProtuctsCenter", undefined, window.innerWidth)
          )
          .then((response) => {
            setLoading(false);
            const data = response.data;
            console.log(response.data);
            setData(data);
            if (!stateAccount.loged) {
              navigate("/");
            }
          });
      }
    }

  }, [awaitingReview, stateAccount.loading])

  const handleClick = (product_id) => {
    setReviewCenterData({
      product_id: product_id,
      scrollToReview: true,
    });
  };

  return (
    <div className="flex min-h-screen">

      <nav className="w-64 bg-dborderblack1 text-white flex flex-col p-4">
        <h2 className="text-xl font-bold mb-6">Review Center</h2>
        <button onClick={() => setAwaitingReview(true)} className={`mb-4 p-2 rounded ${awaitingReview  &&  "bg-white border-blue-800 text-dborderblack1"}`}>Awaiting Review</button>
        <button onClick={() => setAwaitingReview(false)} className={`mb-4 p-2 rounded ${!awaitingReview  &&  "bg-white border-blue-800 text-dborderblack1"}`}>Reviewed</button>
      </nav>


      <div className="flex-1 p-6 bg-gray-100">
      {loading ? (
              <div className="flex justify-center w-full">
                <DotsLoader />
              </div>
            ) : (
              <>
              <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4 pt-4">
                {data?.data?.products && data.data.products.length > 0 ? (
                  data.data.products.map((item) => (
                    <div
                      key={item.product_id}
                      onClick={() => handleClick(item.product_id)}
                    >
                      <SingleProduct item={item} />
                    </div>
                  ))
                ) : null}
              </div>

              {/* Show error if success is false */}
              {!data?.success && (
                <div className="flex items-center justify-center capitalize">
                  {data?.errors?.[0]?.errorMsg || "An error occurred."}
                </div>
              )}


              </>
              
            )}
      </div>
    </div>
  )
}

export default ReviewCenter